

export enum AccessbilityFeatureEnum {
    LIBRAS = 'LIBRAS',
    AUDIO = 'AUDIO',
    NORMAL = 'NORMAL',
}